<template>
  <div class="">
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >

      <el-form-item label="关键字">
        <el-input v-model="form.key_word" />
      </el-form-item>

      <el-form-item label="手机">
        <el-select v-model="form.phone_id" placeholder="请选择手机" style="margin-right: 10px;">
          <el-option
            v-for="item in mobilePhones"
            :key="item.id"
            :label="item.phone_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="客服">
        <el-select v-model="form.customer_id" placeholder="请选择客服" style="margin-right: 10px;">
          <el-option
            v-for="item in customerServices"
            :key="item.id"
            :label="item.customer_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mobilePhoneList, enterpriseWeChatCustomerServiceList } from '@/api/enterpriseWeChatCustomerService'
export default {
  data() {
    return {
      form: {
        customer_id: null,
        key_word: null,
        phone_id: null
      },
      mobilePhones: [],
      customerServices: [],
      token: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    onSubmit() {
      const bool = this.judge()
      bool && this.$emit('determine', this.form)
    },

    async init() {
      const data = await mobilePhoneList()
      const data1 = await enterpriseWeChatCustomerServiceList()
      this.mobilePhones = data.data.list
      this.customerServices = data1.data.list
    },

    judge() {
      let text = null
      if (!this.form.customer_id) {
        text = '请选择客服'
      } else if (!this.form.phone_id) {
        text = '请选择手机'
      } else if (!this.form.key_word) {
        text = '请输入关键字'
      }
      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    }
  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover{
   border-color: rgb(7, 123, 201);
}

.erBox:hover::after,.erBox:hover::before{
   background-color: rgb(7, 123, 201);
}

.file{
  display: none;
}

.imgBox{
   width: 100px;
   height: 100px;
   position: relative;
}

.imgBox:hover span{
   display: inline-block !important;
}

.imgBox span{
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi{
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
